export const UPGRADE_URL = "https://www.metabase.com/upgrade";
export const DATA_STUDIO_UPGRADE_URL = `${UPGRADE_URL}/data-studio`;
